import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=ff6117fa&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=js&"
export * from "./ReportPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=ff6117fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6117fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff6117fa')) {
      api.createRecord('ff6117fa', component.options)
    } else {
      api.reload('ff6117fa', component.options)
    }
    module.hot.accept("./ReportPage.vue?vue&type=template&id=ff6117fa&scoped=true&", function () {
      api.rerender('ff6117fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/ReportPage.vue"
export default component.exports